/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Must_Be_Ad_ToastInputs */

const en_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected Event Group must be of type: Audio Description`)
};

const fr_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d'evenements selectionne doit etre de type : Description audio`)
};

const de_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ausgewählte Ereignisgruppe muss vom Typ „Audiobeschreibung“ sein.`)
};

const it_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo di eventi selezionato deve essere di tipo: Descrizione audio`)
};

const ru_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранная группа событий должна быть типа: Аудиоописание`)
};

const es_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de eventos seleccionado debe ser del tipo: Descripción de audio`)
};

const zh_cn2_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选活动组必须为：音频描述`)
};

const ja_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベント グループのタイプは、オーディオ説明である必要があります。`)
};

const hi_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह का प्रकार ऑडियो विवरण होना चाहिए।`)
};

const pt_pt2_render_audio_must_be_ad_toast = /** @type {(inputs: Render_Audio_Must_Be_Ad_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos selecionado deve ser do tipo: Descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Selected Event Group must be of type: Audio Description" |
*
* @param {Render_Audio_Must_Be_Ad_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_must_be_ad_toast = /** @type {((inputs?: Render_Audio_Must_Be_Ad_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Must_Be_Ad_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_must_be_ad_toast(inputs)
	if (locale === "de") return de_render_audio_must_be_ad_toast(inputs)
	if (locale === "it") return it_render_audio_must_be_ad_toast(inputs)
	if (locale === "ru") return ru_render_audio_must_be_ad_toast(inputs)
	if (locale === "es") return es_render_audio_must_be_ad_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_must_be_ad_toast(inputs)
	if (locale === "ja") return ja_render_audio_must_be_ad_toast(inputs)
	if (locale === "hi") return hi_render_audio_must_be_ad_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_must_be_ad_toast(inputs)
	return en_render_audio_must_be_ad_toast(inputs)
});